








































































































































































































































































































/* eslint-disable @typescript-eslint/no-non-null-assertion */
import Vue from 'vue'
import JWTUtils from '@/utils/JWTUtils'
import InputFileImage from '@/utils/InputFileImage'
import TridentShooter from '@/utils/TridentShooter'

import HelpBalloon from '@/components/organisms/HelpBalloon.vue'
import Accordion from '@/components/organisms/Accordion.vue'
import UploadFile from '@/components/atoms/UploadFile.vue'
import { BModal } from 'bootstrap-vue'
import OnlineService from '@/services/OnlineService'

type FileImageType =
  'drivingLicenseFrontImage' | 'drivingLicenseRearImage' | 'myNumberNotificationCardFrontImage' | 'myNumberNotificationCardRearImage' | 'myNumberCardFrontImage' | 'myNumberCardRearImage';

type FileChangeCallbacks = 'drivingLicenseFrontImageChange' | 'myNumberNotificationCardFrontImageChange';

type CardType = 'card-type-1' | 'card-type-2';

type Data = {
  disabled: boolean;
  isMounted: boolean;
  cardType: CardType | null;
  drivingLicenseFrontImage: InputFileImage | null;
  drivingLicenseRearImage: InputFileImage | null;
  myNumberNotificationCardFrontImage: InputFileImage | null;
  myNumberNotificationCardRearImage: InputFileImage | null;
  myNumberCardFrontImage: InputFileImage | null;
  myNumberCardRearImage: InputFileImage | null;
  errorMessage: string | null;
  alertModalMessage: string | null;
  showRearMessage: {
    drivingLicense: boolean;
    myNumberNotificationCard: boolean;
  };
  tridents: TridentShooter[];
};

export default Vue.extend({
  name: 'Upload',
  components: {
    HelpBalloon,
    Accordion,
    UploadFile
  },
  data (): Data {
    return {
      disabled: false,
      isMounted: false, // 念の為、InputFileImage 設定前に 登録ボタンを押せなくするフラグ
      cardType: null,
      // ▼▼ InputFileImage InputFileImageのインスタンス
      drivingLicenseFrontImage: null,
      drivingLicenseRearImage: null,
      myNumberNotificationCardFrontImage: null,
      myNumberNotificationCardRearImage: null,
      myNumberCardFrontImage: null,
      myNumberCardRearImage: null,
      // ▲▲ InputFileImage
      errorMessage: null,
      alertModalMessage: null,
      showRearMessage: {
        drivingLicense: false,
        myNumberNotificationCard: false
      },
      tridents: []
    }
  },
  computed: {
    isActiveCardType1 (): boolean {
      return this.cardType === 'card-type-1'
    },
    isActiveCardType2 (): boolean {
      return this.cardType === 'card-type-2'
    }
  },
  mounted () {
    /**
     * TridentShooter.shoot を先に行う
     * 1. label img に clickイベントを設定する
     * 2. InputFileImage で動的に作成した img.thumbnail に clickイベントを設定する
     * ※ 2 を先に行うと、img.thumbnail の clickイベントが重複する
     */
    if (TridentShooter.isNeeded()) {
      // IEの場合は、imgをclick は、スクリプトで親要素のlabelをクリックする
      this.tridents = TridentShooter.shoot()
    }
    Array.from(document.querySelectorAll('.image-uploader input[type="file"]'))
      .forEach((node: Element) => {
        this[node.id as FileImageType] = new InputFileImage(
          node as HTMLElement,
          this.callbackImageChanged,
          this.showAlertModal
        )
      })
    this.isMounted = true
  },
  beforeDestroy () {
    this.tridents.forEach(node => node.destroy())
    Array.from(document.querySelectorAll('.image-uploader input[type="file"]'))
      .forEach(node => {
        this[node.id as FileImageType]!.destroy()
      })
  },
  methods: {
    showAlertModal (message: string): void {
      this.alertModalMessage = message as string
      (this.$refs['alert-modal'] as BModal).show()
    },
    /**
     * InputFileImage で 選択した画像が問題ない場合に呼ばれる
     */
    callbackImageChanged (id: string): void {
      // 後処理がある場合実行する
      const func = id + 'Change' as FileChangeCallbacks
      if (Object.prototype.hasOwnProperty.call(this, func) && typeof this[func] === 'function') {
        // dom更新後に実行
        this.$nextTick(() => this[func]())
      }
    },
    /**
     * 運転免許書（表）後処理
     */
    drivingLicenseFrontImageChange (): void {
      if (this.drivingLicenseFrontImage!.getFile(false) && !this.drivingLicenseRearImage!.getFile(false)) {
        this.showRearMessage.drivingLicense = true
      }
    },
    /**
     * マイナンバー通知（表）後処理
     */
    myNumberNotificationCardFrontImageChange (): void {
      if (this.myNumberNotificationCardFrontImage!.getFile(false) && !this.myNumberNotificationCardRearImage!.getFile(false)) {
        this.showRearMessage.myNumberNotificationCard = true
      }
    },
    submit (): void {
      if (this.disabled) {
        return
      }
      this.disabled = true
      const { sub: userId } = JWTUtils.getSubject(JWTUtils.get() as string)
      const payload = { userId }
      const params = new FormData()
      params.append('imageDataRegistrationRequest', new Blob([JSON.stringify(payload)], { type: 'application/json' }))
      try {
        if (this.cardType === 'card-type-1') {
          params.append('drivingLicenseFrontImage', this.drivingLicenseFrontImage!.getFile())
          params.append('drivingLicenseRearImage', this.drivingLicenseRearImage!.getFile())
          params.append('myNumberNotificationCardFrontImage', this.myNumberNotificationCardFrontImage!.getFile())
          params.append('myNumberNotificationCardRearImage', this.myNumberNotificationCardRearImage!.getFile())
        }
        if (this.cardType === 'card-type-2') {
          params.append('myNumberCardFrontImage', this.myNumberCardFrontImage!.getFile())
          params.append('myNumberCardRearImage', this.myNumberCardRearImage!.getFile())
        }
      } catch (e) {
        this.showAlertModal('未設定の画像があります')
        this.disabled = false
        return
      }
      OnlineService.imageDataRegistration(params).then(() => {
        // 登録コードの登録画面
        this.$router.push({ name: 'registercoderegistration' })
      }).catch(() => {
        this.errorMessage = '必要な書類がアップロードされているか確認してください。'
        this.disabled = false
      })
    }
  }
})
